import { render, staticRenderFns } from "./CategoriesIcon.vue?vue&type=template&id=3e1cbf72&scoped=true&"
import script from "./CategoriesIcon.vue?vue&type=script&lang=js&"
export * from "./CategoriesIcon.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesIcon.vue?vue&type=style&index=0&id=3e1cbf72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1cbf72",
  null
  
)

export default component.exports